import React from 'react'
import { Link } from 'react-router-dom'
import '../acceptModal/AcceptModal.css'

const AcceptModal = () => {
  return (
    <div className='modal-box-sec accept-modal-sec'>
        <div className="modal fade" id="staticBackdropAccept" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <form action="">
                            <div className='form-group'>
                                <label htmlFor="" className='mb-3'>To accept this booking please select a start time 
                                between 12pm-6pm.</label>
                                <input type="text" className="form-control" id="" placeholder="00:00" />
                            </div>
                            <div className='btn btn-group align-items-center m-auto d-flex justify-content-center'>
                                <Link rel='stylesheet' to="/" className='btn btn-border border-active'> Accept</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AcceptModal
